import React from 'react';
import './styles.css';
import PropTypes from 'prop-types';

const InputForm = ({
  inputMessage,
  onChange,
  onKeyPress,
  onClick,
  required,
  disabled,
}) => (
  <>
    <input
      id="input"
      type="text"
      value={inputMessage}
      name="inputMessage"
      onChange={onChange}
      onKeyPress={onKeyPress}
      className="input-form"
      placeholder="Escreva aqui sua mensagem..."
      autoComplete="off"
      required={required}
      disabled={disabled}
    />
    <button className="input-icon" type="button" onClick={onClick}>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        viewBox="0 0 500 500"
      >
        <g>
          <g>
            <polygon points="0,497.25 535.5,267.75 0,38.25 0,216.75 382.5,267.75 0,318.75" />
          </g>
        </g>
      </svg>
    </button>
  </>
);

InputForm.propTypes = {
  inputMessage: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
};

export default InputForm;
